import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppDialogProvider } from "./components/AppDialog";
import { initSpaSentry } from "./lib/sentry";
import "./styles/global.css";

// Sentry must init before app render so it instruments React early.
initSpaSentry();

// Pick up the JWT handed off from accounts.prototypical.ai. accounts
// arrives at app.protopal.ai/#access_token=<jwt> after a successful
// SSO login or "already signed in" bounce. Stash the token in our own
// sessionStorage and scrub the URL so the token doesn't sit in
// browser history more than necessary.
(function consumeAccessTokenFragment() {
  const hash = window.location.hash;
  if (!hash) return;
  const params = new URLSearchParams(hash.slice(1));
  const token = params.get("access_token");
  if (token) {
    sessionStorage.setItem("protopal_token", token);
    params.delete("access_token");
    const remainingHash = params.toString();
    const cleanedUrl =
      window.location.pathname +
      window.location.search +
      (remainingHash ? `#${remainingHash}` : "");
    window.history.replaceState({}, "", cleanedUrl);
  }
})();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AppDialogProvider>
        <App />
      </AppDialogProvider>
    </BrowserRouter>
  </StrictMode>,
);
